export const enabledBlockTemplates = [
  {
    id: 523,
    documentId: 27505,
    ownerId: 2,
    name: 'Alert',
    description: '',
    image: 'https://media.candulabs.com/1/alert-3.svg',
    scope: 'Block',
    enabled: true,
    category: '1 Announcement Bars',
    lastModifiedAt: '2022-05-21T22:18:48.010Z',
    longDescription: '',
    tags: ['\uD83E\uDDF1'],
    creatorName: '',
    creatorPicture: '',
    creatorOrganizationName: '',
    creatorOrganizationPicture: '',
  },
];
